import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { PrecipitationConverter } from "./precipitation-value";
import { MeasurementSystems } from "./measurement-systems";

@autoinject
export class PrecipitationFormatValueConverter {
	constructor(private i18n: I18N) { }

	toView(value: number) {

		if (isNaN(value)) {
			return this.i18n.tr("offline");
		}
		let measurementSystem = localStorage.getItem("measurement-system");
		if (!measurementSystem) {
			measurementSystem = MeasurementSystems.imperial;
		}

		switch (measurementSystem) {
			case MeasurementSystems.metric:
			return `${value.toFixed(1)} mm/H`;
		default:
			const precipitation = PrecipitationConverter.toImperial(value);
			return `${precipitation.toFixed(1)} in/H`;
		}

	}
}



